import { render, staticRenderFns } from "./ApplyList.vue?vue&type=template&id=b85da87c&"
import script from "./ApplyList.vue?vue&type=script&lang=js&"
export * from "./ApplyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports